<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="8">
            <h4>Danh sách bài viết</h4>
          </b-col>
          <b-col class="text-right" cols="4">
            <b-button class="btn-sm" variant="primary" @click="New()">
              <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
              Thêm mới bài viết
            </b-button>
          </b-col>
          <!-- Per Page -->
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="options.fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :rows="items"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"

            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span>
                    <b-button
                        class="btn-icon"
                        size="sm"
                        variant="primary"
                        @click="Edit(props.row, props.row.id)"
                    >
                      <feather-icon icon="Edit2Icon"/>
                    </b-button>
                    <b-button
                        class="btn-icon"
                        size="sm"
                        style="margin-left: 6px"
                        variant="danger"
                        @click="DeleteItem(props.row, props.row.id)"
                    >
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                  </span>
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="lg" @ok="handleOk">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Chọn chủ đề">
            <Select2
                v-model="currentItem.CategoryID"
                :options="itemsLv2"
                placeholder="Chọn chủ đề"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Tiêu đề bài viết">
            <b-form-input
                v-model="currentItem.Title"
                placeholder="Nhập tiêu đề"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Mô tả bài viết">
            <b-form-input
                v-model="currentItem.Description"
                placeholder="Nhập tiêu đề"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Nội dung bài viết">
            <b-form-textarea
                id="textarea-auto-height"
                v-model="currentItem.Content"
                max-rows="20"
                placeholder="Nhập nội dung"
                rows="10"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";

export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
  },
  methods: {
    getTitle() {
      if (this.editMode) {
        return "Cập nhật bài viết ";
      } else {
        return "Thêm mới bài viết ";
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    loadItems() {
      useJwt
          .post("/news/search", {
            columnFilters: {},
          })
          .then((response) => {
            this.items = response.data.result;
            this.totalRecords = response.data.totalRecords;
            this.isLoading = false;
          });
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới bài viết ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật ";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `news/posts/${item.ID}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu bài viết",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          let res = await useJwt.delete(url);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá bài viết thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá bài viết ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.editMode) {
        const url = `news/posts/${this.currentItem.ID}`;
        const updateParams = {
          ID: this.currentItem.ID,
          Title: this.currentItem.Title,
          Description: this.currentItem.Description,
          Content: this.currentItem.Content,
          Creator: "admin@itelecom.vn",
          PublishDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          Status: 1,
          ViewCount: 1,
          CategoryID: this.currentItem.CategoryID,
          Tags: [],
        };
        try {
          const res = await useJwt.put(url, updateParams);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi thêm mới bài viết ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          ID: 0,
          Title: this.currentItem.Title,
          Description: this.currentItem.Description,
          Content: this.currentItem.Content,
          Creator: "admin@itelecom.vn",
          PublishDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          Status: 1,
          ViewCount: 1,
          CategoryID: this.currentItem.CategoryID,
          Tags: [],
        };
        const res = await useJwt.post("news/posts", createParams);
        if (res.data.code == 200) {
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới bài viết thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.$bvModal.hide("modal-edit");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới bài viết ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },

    async loadTopics() {
      useJwt.get("/news/categories").then((response) => {
        this.isLoading = false;
        // mapping groups item level 2
        const arrItemsLv1 = response.data.result.filter(
            (item) => item.Level == 2
        );

        this.itemsLv2 = arrItemsLv1.map((item) => {
          return {
            id: item.ID,
            text: item.Name,
          };
        });
        console.log("itel lv2 ", this.itemsLv2);
      });
    },
  },

  mounted() {
    this.loadItems();
    this.loadTopics();
  },
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      items: [],
      tags: [],
      itemsLv2: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      editPhoneNote: "",
      options: {
        fields: [
          {
            field: "ID",
            filterOptions: {enabled: false, placeholder: ""},
            label: "ID",
            required: true,
            disabled: true,
          },
          {
            field: "Title",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Title",
            required: true,
            disabled: true,
          },
          {
            field: "Description",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Description",
            required: true,
            disabled: true,
          },
          {
            field: "CreateDate",
            filterOptions: {enabled: false, placeholder: ""},
            label: "CreateDate",
            required: true,
            disabled: true,
          },

          {
            field: "ViewCount",
            filterOptions: {enabled: false, placeholder: ""},
            label: "ViewCount",
            required: true,
            disabled: true,
          },
          {
            field: "CategoryID",
            filterOptions: {enabled: false, placeholder: ""},
            label: "CategoryID",
            required: true,
            disabled: true,
          },

          {field: "action", label: "Actions", width: "120px"},
        ],
      },
    };
  },
};
</script>

<style>
</style>
